/**
 * Offline mirror of prior-auth-service CodeSets.json (array tables used by dropdowns).
 * Map-style lookup tables are omitted — they are not used as Sample Value selects.
 */
export const CODE_SETS = {
  entityIdentifier: [
    { code: "X3", description: "Utilization Management Organization" },
    { code: "1P", description: "Provider" },
    { code: "IL", description: "Insured or Subscriber" },
    { code: "QC", description: "Patient" },
    { code: "FA", description: "Facility" },
    { code: "SJ", description: "Service Provider (Rendering)" },
    { code: "P3", description: "Primary Care Provider" },
    { code: "DK", description: "Ordering / Referring Provider" },
    { code: "71", description: "Attending Physician" },
    { code: "72", description: "Operating Physician" },
    { code: "73", description: "Other Operating Physician" },
    { code: "DD", description: "Assistant Surgeon" },
    { code: "DQ", description: "Supervising Physician" },
    { code: "QB", description: "Purchased Service Provider" },
  ],
  entityTypeQualifier: [
    { code: "1", description: "Person" },
    { code: "2", description: "Non-Person Entity" },
  ],
  idQualifier: [
    { code: "PI", description: "Payer Identification" },
    { code: "XX", description: "National Provider Identifier (NPI)" },
    { code: "MI", description: "Member Identification Number" },
    { code: "24", description: "Employer Identification Number (EIN)" },
    { code: "46", description: "Electronic Transmitter Identification Number (ETIN)" },
    { code: "XV", description: "CMS Plan ID" },
  ],
  requestCategory: [
    { code: "AR", description: "Admission Review" },
    { code: "HS", description: "Health Services Review" },
    { code: "SC", description: "Specialty Care Review" },
    { code: "IN", description: "Individual Reservation" },
  ],
  certificationAction: [
    { code: "I", description: "Initial" },
    { code: "R", description: "Renewal" },
    { code: "S", description: "Revised" },
    { code: "3", description: "Cancel" },
    { code: "4", description: "Extension" },
    { code: "1", description: "Appeal / Immediate" },
  ],
  bhtPurposeCode: [
    { code: "13", description: "Request" },
    { code: "01", description: "Cancellation" },
    { code: "36", description: "Authority to Deduct" },
  ],
  bhtTransactionTypeCode: [
    { code: "", description: "Omit BHT06 (None)" },
    { code: "RU", description: "Medical Services Reservation" },
  ],
  admissionType: [
    { code: "1", description: "Emergency" },
    { code: "2", description: "Urgent" },
    { code: "3", description: "Elective" },
    { code: "4", description: "Newborn" },
    { code: "5", description: "Trauma" },
  ],
  levelOfService: [
    { code: "03", description: "Emergency" },
    { code: "U", description: "Urgent" },
    { code: "E", description: "Elective" },
  ],
  placeOfService: [
    { code: "11", description: "Office" },
    { code: "21", description: "Inpatient Hospital" },
    { code: "22", description: "Outpatient Hospital" },
    { code: "23", description: "Emergency Room - Hospital" },
    { code: "24", description: "Ambulatory Surgical Center" },
    { code: "31", description: "Skilled Nursing Facility" },
    { code: "32", description: "Nursing Facility" },
    { code: "41", description: "Ambulance - Land" },
  ],
  gender: [
    { code: "M", description: "Male" },
    { code: "F", description: "Female" },
    { code: "U", description: "Unknown" },
  ],
  usageIndicator: [
    { code: "T", description: "Test" },
    { code: "P", description: "Production" },
  ],
  quantityType: [
    { code: "UN", description: "Units" },
    { code: "DA", description: "Days" },
    { code: "HR", description: "Hours" },
    { code: "MJ", description: "Minutes" },
    { code: "MO", description: "Months" },
    { code: "WK", description: "Weeks" },
    { code: "VS", description: "Visits" },
  ],
  diagnosisQualifier: [
    { code: "ABK", description: "Principal Diagnosis (ICD-10-CM)" },
    { code: "ABF", description: "Additional Diagnosis (ICD-10-CM)" },
  ],
  certificationCategory: [
    { code: "07", description: "Ambulance Certification" },
    { code: "08", description: "Chiropractic Certification" },
    { code: "09", description: "DME Certification" },
    { code: "11", description: "Nursing Home Residential Status" },
    { code: "75", description: "Oxygen Therapy Certification" },
    { code: "76", description: "Home Health Certification" },
  ],
  hcrDecision: [
    { code: "A1", description: "Certified in Total" },
    { code: "A2", description: "Certified - Partial" },
    { code: "A3", description: "Not Certified" },
    { code: "A4", description: "Pended" },
    { code: "A6", description: "Modified" },
  ],
  claimType: [
    { code: "professional", description: "Professional Claim" },
    { code: "institutional", description: "Institutional Claim" },
  ],
  priorAuthPriority: [
    { code: "stat", description: "Stat" },
    { code: "asap", description: "ASAP" },
    { code: "urgent", description: "Urgent" },
    { code: "normal", description: "Normal" },
  ],
  yesNo: [
    { code: "Y", description: "Yes" },
    { code: "N", description: "No" },
  ],
};

/** elementId → CodeSets.* from backend Elements.json (offline explorer). */
export const ELEMENT_DROPDOWN_SOURCES = {
  ISA_15: "CodeSets.usageIndicator",
  BHT_02: "CodeSets.bhtPurposeCode",
  NM1_X3_08: "CodeSets.idQualifier",
  DMG_03: "CodeSets.gender",
  DMG_QC_03: "CodeSets.gender",
  UM_EVT_01: "CodeSets.requestCategory",
  UM_EVT_02: "CodeSets.certificationAction",
  UM_EVT_03: "CodeSets.admissionType",
  UM_EVT_04: "CodeSets.placeOfService",
  UM_EVT_06: "CodeSets.levelOfService",
  UM_SVC_01: "CodeSets.requestCategory",
};

/**
 * Resolve dropdown options for a CodeSets.* path.
 * @returns {{ code: string, description: string }[]}
 */
export function getCodeSetOptions(codeSets, dropdownSource) {
  if (!dropdownSource || typeof dropdownSource !== "string") return [];

  const parts = dropdownSource.split(".").map((p) => p.trim()).filter(Boolean);
  if (parts.length < 2 || parts[0].toLowerCase() !== "codesets") return [];

  const tableName = parts[1];
  const root = codeSets || CODE_SETS;
  const table = root[tableName] ?? root[tableName.charAt(0).toLowerCase() + tableName.slice(1)];
  if (!Array.isArray(table)) return [];

  return table
    .map((item) => {
      const code = item?.code != null ? String(item.code) : "";
      const description =
        item?.description != null ? String(item.description) : "";
      return { code, description };
    })
    .filter((item) => item.code !== undefined && item.code !== null);
}
